module.exports = __webpack_public_path__ + "img/Frame4304.6938c2dc.png";